import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, createContext, useEffect, useCallback, useContext } from 'react';
import api from 'utils/api';
import store, { userStore } from 'utils/store';
import { redirectToLogin } from 'utils/auth/getLogoutPath';
import { LOGOUT_EVENT } from 'utils/auth/constants';
import { addHeapTrackingIfRequired } from 'utils/heapTracking';
import { addMindsetAIIfRequired } from 'utils/mindset';
import { jsx as _jsx } from "react/jsx-runtime";
var AuthContext = /*#__PURE__*/createContext({
  authUser: null,
  setAuthUser: function setAuthUser() {
    return null;
  }
});
function useAuthContext() {
  var context = useContext(AuthContext);
  if (context === undefined) {
    throw Error('useAuthContext must be used inside of a AuthProvider');
  }
  return context;
}
function AuthProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  var setAuthUser = useCallback(function (user) {
    if (user) {
      userStore(user);
    } else {
      store.clear();
    }
    setUser(user);
  }, []);
  useEffect(function () {
    var onStorageUpdate = function onStorageUpdate(event) {
      if (event.key === LOGOUT_EVENT) {
        setAuthUser(null);
        redirectToLogin();
      }
    };
    window.addEventListener('storage', onStorageUpdate);
    return function () {
      return window.removeEventListener('storage', onStorageUpdate);
    };
  }, [setAuthUser]);
  useEffect(function () {
    function checkLoggedIn() {
      return _checkLoggedIn.apply(this, arguments);
    }
    function _checkLoggedIn() {
      _checkLoggedIn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data, userId, domain, domainId, isAdmin, role, _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return api('get', '/auth/login');
            case 1:
              data = _context.sent;
              setAuthUser(data);

              // add Heap Analytics and Mindset AI
              userId = data.id, domain = data.domain, domainId = data.domainId, isAdmin = data.isAdmin, role = data.role;
              addHeapTrackingIfRequired({
                userId: userId,
                domain: domain,
                domainId: domainId,
                isAdmin: isAdmin,
                role: role
              });
              addMindsetAIIfRequired();
              if (!isAdmin) {
                window.location.href = '/home';
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              setAuthUser(null);
              redirectToLogin();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _checkLoggedIn.apply(this, arguments);
    }
    checkLoggedIn();
  }, [setAuthUser]);
  return /*#__PURE__*/_jsx(AuthContext.Provider, {
    value: {
      authUser: user,
      setAuthUser: setAuthUser
    },
    children: children
  });
}
export { AuthProvider, AuthContext, useAuthContext };